'use client'

import { useMemo } from 'react'

import { Collapse } from 'shared/ui/Collapse'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import { MultipacksTypes, ProductTypes } from '../../../types/products'
import { getQuantityUnit } from '../../../utils/quantity'
import ProductSet from '../../ProductSet'

import styles from './ProductCardProductSets.module.scss'

interface ProductCardPProductSetsProps {
  product: ProductTypes
  onQuantityJumpChange: (quantity: number) => void
  quantityJump: number
  isHovered: boolean
}

const ProductCardProductSets = ({
  product,
  onQuantityJumpChange,
  quantityJump,
  isHovered
}: ProductCardPProductSetsProps) => {
  const { multipacks } = product

  const getMultipacks = (mp: MultipacksTypes[]) => {
    return mp.map(el => el.quantity)
  }

  const productSets: number[] = useMemo(() => {
    return isNotNilOrEmpty(multipacks) ? getMultipacks(multipacks) : [1]
  }, [multipacks])

  const productSetsList = useMemo(() => {
    return productSets.map((set: number, i) => (
      <ProductSet
        key={`${set} id ${i}`}
        active={quantityJump === set}
        onClick={() => onQuantityJumpChange(set)}
      >
        {getQuantityUnit(set)}
      </ProductSet>
    ))
  }, [productSets, quantityJump, onQuantityJumpChange])

  if (productSets.length <= 1) return null

  return (
    <div className={styles.root}>
      <div className={styles.webContent}>
        <Collapse open={isHovered}>
          <div className={styles.expandableContent}>
            <div className={styles.productSets}>{productSetsList}</div>
          </div>
        </Collapse>
      </div>
      <div className={styles.tabletContent}>
        <div className={styles.productSets}>{productSetsList}</div>
      </div>
    </div>
  )
}

export default ProductCardProductSets
